import { NavConfig } from "../types";
import {
  DashboardLogo,
  AdminPanelLogo,
  NexusLogo,
  InvestmentsLogo,
  TradingLogo,
  ResponsumOSLogo,
  RealEstateLogo,
  SmartHomeLogo,
  SettingsLogo,
  LLMLogo,
} from "@/components/icons";

export const navigationConfig: NavConfig = {
  brand: {
    title: "TracQ",
    href: "/dashboard",
  },
  sections: [
    {
      id: "core",
      title: "Core",
      items: [
        {
          id: "dashboard",
          label: "Dashboard",
          href: "/dashboard",
          icon: DashboardLogo,
        },
        {
          id: "admin",
          label: "Admin Panel",
          href: "/admin",
          icon: AdminPanelLogo,
        },
      ],
    },
    {
      id: "workspaces",
      title: "Workspaces",
      items: [
        {
          id: "nexus",
          label: "Nexus",
          href: "/nexus",
          icon: NexusLogo,
        },
        {
          id: "investments",
          label: "Investments",
          href: "/investments",
          icon: InvestmentsLogo,
        },
        {
          id: "trading",
          label: "Trading",
          href: "/trading",
          icon: TradingLogo,
        },
        {
          id: "responsum-os",
          label: "ResponsumOS",
          href: "/responsumos",
          icon: ResponsumOSLogo,
        },
        {
          id: "real-estate",
          label: "Real Estate",
          href: "/real-estate",
          icon: RealEstateLogo,
        },
        {
          id: "smart-home",
          label: "Smart Home",
          href: "/smarthome",
          icon: SmartHomeLogo,
        },
      ],
    },
    {
      id: "support",
      title: "Support & Settings",
      items: [
        {
          id: "llm",
          label: "LLM",
          href: "/llm",
          icon: LLMLogo,
        },
        {
          id: "settings",
          label: "Settings",
          href: "/settings",
          icon: SettingsLogo,
        },
      ],
    },
  ],
  actions: {
    search: true,
    notifications: true,
    user: true,
  },
};
